/**
 * Code-split an editing-only component out of the reader bundle.
 *
 *   const link_editor = lazy(() => import('#lib/LinkEditor.svelte'));
 *   ...
 *   {#if is_editing && link_editor.component}
 *     <link_editor.component ... />
 *   {/if}
 *
 * Reading `.component` starts the download if it has not started, and re-renders once the
 * chunk is in. Call `load()` ahead of time (entering edit mode, hovering the trigger) so the
 * component is already here when it has to show - only use this for components that cannot
 * be visible at page load and sit behind at least one deliberate user action.
 */
export function lazy(loader) {
  let component = $state.raw(null);
  let promise = null;
  const load = () => (promise ??= loader().then(module => (component = module.default)));
  return {
    load,
    get component() {
      if (!component) load();
      return component;
    },
  };
}
